export const regions = [
  { id: 'all', label: 'All Regions' },
  { id: 'metro-manila', label: 'Metro Manila' },
  { id: 'luzon', label: 'Luzon' },
  { id: 'visayas', label: 'Visayas' },
  { id: 'mindanao', label: 'Mindanao' },
  { id: 'online', label: 'Online' },
];

export const partnerCategories = [
  { id: 'all', label: 'All Types' },
  { id: 'supermarket', label: 'Supermarkets' },
  { id: 'health', label: 'Health Stores' },
  { id: 'grocery', label: 'Grocery Chains' },
  { id: 'online', label: 'Online Platforms' },
  { id: 'distributor', label: 'Distributors' },
];

export interface RetailPartner {
  id: number;
  name: string;
  type: string;
  region: string;
  locations: string[];
  address: string;
  city: string;
  badge?: string;
  logo: string;
  products: string[];
  storeCount: number;
}

export const retailPartners: RetailPartner[] = [
  {
    id: 1,
    name: 'SM Supermarket',
    type: 'supermarket',
    region: 'metro-manila',
    locations: ['SM Mall of Asia', 'SM Megamall', 'SM North EDSA', 'SM Aura', 'SM Fairview'],
    address: 'Multiple Branches, Metro Manila',
    city: 'Metro Manila',
    badge: 'Featured Partner',
    logo: 'https://public.readdy.ai/ai/img_res/1c851a30bdca8af501cc651474ba43c3.jpg',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables', 'Custom Blends'],
    storeCount: 5,
  },
  {
    id: 2,
    name: 'Robinsons Supermarket',
    type: 'supermarket',
    region: 'metro-manila',
    locations: ['Robinsons Galleria', 'Robinsons Ermita', 'Robinsons Pioneer', 'Robinsons Manila'],
    address: 'Multiple Branches, Metro Manila',
    city: 'Metro Manila',
    badge: 'Featured Partner',
    logo: 'https://readdy.ai/api/search-image?query=bright%20modern%20grocery%20store%20interior%20health%20food%20section%20with%20colorful%20natural%20product%20packaging%20on%20shelves%20professional%20photography%20clean%20white%20background%20retail%20environment&width=200&height=200&seq=ret002&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Custom Blends'],
    storeCount: 4,
  },
  {
    id: 3,
    name: 'Healthy Options',
    type: 'health',
    region: 'metro-manila',
    locations: ['BGC', 'Greenbelt', 'Shangri-La Plaza', 'Alabang Town Center'],
    address: 'Multiple Branches, Metro Manila',
    city: 'BGC, Taguig',
    badge: 'Health Partner',
    logo: 'https://readdy.ai/api/search-image?query=organic%20health%20food%20store%20interior%20with%20natural%20wooden%20shelves%20featuring%20premium%20healthy%20snack%20products%20clean%20minimalist%20retail%20space%20bright%20lighting%20natural%20tones%20professional%20photography&width=200&height=200&seq=ret003&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables'],
    storeCount: 4,
  },
  {
    id: 4,
    name: 'Puregold Supermarket',
    type: 'grocery',
    region: 'metro-manila',
    locations: ['Puregold Cubao', 'Puregold Mandaluyong', 'Puregold Parañaque'],
    address: 'Multiple Branches, Metro Manila',
    city: 'Metro Manila',
    logo: 'https://readdy.ai/api/search-image?query=large%20grocery%20store%20retail%20shelf%20with%20packaged%20food%20products%20neatly%20arranged%20vibrant%20packaging%20colors%20clean%20professional%20retail%20photography%20minimal%20background&width=200&height=200&seq=ret004&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables'],
    storeCount: 3,
  },
  {
    id: 5,
    name: 'Lazada Philippines',
    type: 'online',
    region: 'online',
    locations: ['Nationwide Delivery'],
    address: 'Online Platform',
    city: 'Online',
    badge: 'Official Store',
    logo: 'https://readdy.ai/api/search-image?query=e-commerce%20online%20shopping%20platform%20product%20listing%20freeze%20dried%20snacks%20displayed%20on%20digital%20device%20screen%20minimalist%20clean%20design%20professional%20product%20photography%20white%20background&width=200&height=200&seq=ret005&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables', 'Custom Blends'],
    storeCount: 1,
  },
  {
    id: 6,
    name: 'Shopee Philippines',
    type: 'online',
    region: 'online',
    locations: ['Nationwide Delivery'],
    address: 'Online Platform',
    city: 'Online',
    badge: 'Official Store',
    logo: 'https://readdy.ai/api/search-image?query=mobile%20online%20shopping%20app%20product%20page%20showing%20premium%20food%20snacks%20modern%20clean%20UI%20design%20professional%20product%20imagery%20minimal%20white%20background%20digital%20commerce&width=200&height=200&seq=ret006&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables', 'Custom Blends'],
    storeCount: 1,
  },
  {
    id: 7,
    name: 'Gaisano Grand Mall',
    type: 'supermarket',
    region: 'visayas',
    locations: ['Cebu City', 'Mandaue', 'Lapu-Lapu City'],
    address: 'Gaisano Grand Mall, Cebu City',
    city: 'Cebu City',
    badge: 'Visayas Partner',
    logo: 'https://readdy.ai/api/search-image?query=regional%20supermarket%20store%20interior%20Cebu%20Philippines%20with%20product%20shelves%20local%20food%20items%20clean%20bright%20retail%20space%20professional%20photography%20neutral%20background&width=200&height=200&seq=ret007&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Custom Blends'],
    storeCount: 3,
  },
  {
    id: 8,
    name: 'Ayala Supermarket Cebu',
    type: 'grocery',
    region: 'visayas',
    locations: ['Ayala Center Cebu'],
    address: 'Ayala Center, Cebu City',
    city: 'Cebu City',
    logo: 'https://readdy.ai/api/search-image?query=upscale%20supermarket%20health%20food%20aisle%20with%20premium%20snack%20products%20natural%20organic%20produce%20clean%20contemporary%20retail%20environment%20professional%20photography%20light%20background&width=200&height=200&seq=ret008&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables'],
    storeCount: 1,
  },
  {
    id: 9,
    name: 'NCCC Mall Davao',
    type: 'supermarket',
    region: 'mindanao',
    locations: ['Davao City', 'Ulas', 'Buhangin'],
    address: 'NCCC Mall, Davao City',
    city: 'Davao City',
    badge: 'Mindanao Partner',
    logo: 'https://readdy.ai/api/search-image?query=modern%20supermarket%20interior%20Davao%20Philippines%20regional%20grocery%20store%20shelves%20with%20snack%20products%20clean%20bright%20lighting%20professional%20photography%20simple%20background&width=200&height=200&seq=ret009&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Custom Blends'],
    storeCount: 3,
  },
  {
    id: 10,
    name: 'Abreeza Mall Supermarket',
    type: 'grocery',
    region: 'mindanao',
    locations: ['Davao City'],
    address: 'Abreeza Mall, JP Laurel Ave, Davao City',
    city: 'Davao City',
    logo: 'https://readdy.ai/api/search-image?query=clean%20modern%20grocery%20store%20food%20section%20premium%20product%20shelves%20neat%20organized%20display%20professional%20retail%20photography%20minimal%20background%20Davao&width=200&height=200&seq=ret010&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables'],
    storeCount: 1,
  },
  {
    id: 11,
    name: 'SM City Pampanga',
    type: 'supermarket',
    region: 'luzon',
    locations: ['San Fernando, Pampanga'],
    address: 'SM City Pampanga, San Fernando',
    city: 'San Fernando, Pampanga',
    logo: 'https://readdy.ai/api/search-image?query=suburban%20supermarket%20store%20display%20shelves%20with%20premium%20healthy%20snack%20products%20clean%20professional%20retail%20photography%20neutral%20background%20organized%20product%20placement&width=200&height=200&seq=ret011&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Custom Blends'],
    storeCount: 1,
  },
  {
    id: 12,
    name: 'Vista Mall Sta. Rosa',
    type: 'grocery',
    region: 'luzon',
    locations: ['Sta. Rosa, Laguna'],
    address: 'Vista Mall, Sta. Rosa City, Laguna',
    city: 'Sta. Rosa, Laguna',
    logo: 'https://readdy.ai/api/search-image?query=modern%20mall%20supermarket%20south%20Luzon%20Philippines%20shelves%20food%20products%20clean%20organized%20bright%20professional%20retail%20photography%20light%20background&width=200&height=200&seq=ret012&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables', 'Custom Blends'],
    storeCount: 1,
  },
  {
    id: 13,
    name: 'NutriAsia Distributors',
    type: 'distributor',
    region: 'luzon',
    locations: ['Bulacan', 'Batangas', 'Cavite', 'Laguna', 'Rizal'],
    address: 'Distribution Hub, Bulacan',
    city: 'Bulacan',
    badge: 'Authorized Distributor',
    logo: 'https://readdy.ai/api/search-image?query=logistics%20distribution%20warehouse%20with%20stacked%20boxes%20pallets%20of%20food%20products%20organized%20storage%20facility%20professional%20photography%20neutral%20industrial%20background&width=200&height=200&seq=ret013&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables', 'Custom Blends'],
    storeCount: 5,
  },
  {
    id: 14,
    name: 'Visayas Fresh Distributors',
    type: 'distributor',
    region: 'visayas',
    locations: ['Cebu', 'Iloilo', 'Bacolod', 'Tacloban'],
    address: 'Cebu North Road, Mandaue City',
    city: 'Mandaue, Cebu',
    badge: 'Authorized Distributor',
    logo: 'https://readdy.ai/api/search-image?query=distribution%20center%20Philippines%20with%20packaged%20food%20products%20organized%20on%20warehouse%20shelves%20ready%20for%20delivery%20logistics%20professional%20photography%20clean%20background&width=200&height=200&seq=ret014&orientation=squarish',
    products: ['Freeze Dried Fruits', 'Freeze Dried Vegetables'],
    storeCount: 4,
  },
];

export const distributionAreas = [
  {
    region: 'Metro Manila',
    id: 'metro-manila',
    coverage: 'Full Coverage',
    stores: 18,
    distributors: 3,
    color: 'bg-amber-100',
    highlight: true,
    cities: ['Makati', 'BGC', 'Quezon City', 'Pasig', 'Mandaluyong', 'Parañaque', 'Alabang'],
  },
  {
    region: 'Luzon',
    id: 'luzon',
    coverage: 'Wide Coverage',
    stores: 24,
    distributors: 4,
    color: 'bg-orange-100',
    highlight: true,
    cities: ['Pampanga', 'Bulacan', 'Batangas', 'Laguna', 'Cavite', 'Batangas', 'Ilocos Norte'],
  },
  {
    region: 'Visayas',
    id: 'visayas',
    coverage: 'Expanding',
    stores: 12,
    distributors: 2,
    color: 'bg-yellow-100',
    highlight: false,
    cities: ['Cebu City', 'Mandaue', 'Lapu-Lapu', 'Iloilo City', 'Bacolod', 'Tacloban'],
  },
  {
    region: 'Mindanao',
    id: 'mindanao',
    coverage: 'Growing',
    stores: 8,
    distributors: 2,
    color: 'bg-lime-100',
    highlight: false,
    cities: ['Davao City', 'Cagayan de Oro', 'General Santos', 'Zamboanga'],
  },
];
